import seqStore from '../../store/seqStore'

export default function GateLength() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const gatePercentage = seqStore((state) => state.settings.gatePercentage)
    const setGatePercentage = seqStore((state) => state.setGatePercentage)

    // GATE LENGTH CONTROLS
    const handleGatePercentage = (e) => {
        const value = e.target.value
        setGatePercentage(currentTrack, value)
    }

    const resetGatePercentage = () => {
        setGatePercentage(currentTrack, 50)
    }

    return (
        <div id='gateLengthInput'>
            <label htmlFor="root note">Gate <span>{gatePercentage[currentTrack]+'%'}</span></label>
            <input id='enabledInput' type="range" min={5} max={95} step='5' value={gatePercentage[currentTrack]} onChange={e => handleGatePercentage(e)} onDoubleClick={resetGatePercentage}/>
        </div>
    )
}
